import { getRegisterLayout } from 'layouts';
import { CustomNextPage, RoleLevels } from 'lib/types';
import { CreateAccountForm } from 'domains/account';
import { VStack, Heading, Box, Text } from '@chakra-ui/react';
import { parse } from 'cookie'
import { GetServerSideProps } from 'next';
import Link from 'next/link';
import { getUser, redirectLoggedInUser } from "lib/server-side";

type Props = {
  defaultEmail?: string;
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  if (ctx.req.cookies?.packs_token) {
    const user = await getUser(ctx);

    if (user) {
      return redirectLoggedInUser(ctx, user);
    }
  }

  const base64Decode = (b64Encoded: string) => Buffer.from(b64Encoded, 'base64').toString();

  const parseJwt = (token: string) => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(base64Decode(base64).split('').map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));

    return JSON.parse(jsonPayload);
  };

  const parsedCookies = parse(ctx.req.headers.cookie || '');

  const defaultEmail = parsedCookies.packs_email_token ? parseJwt(base64Decode(parsedCookies.packs_email_token)).email : null;

  return { props: { defaultEmail } }
}

export const Register: CustomNextPage<Props> = ({ defaultEmail }) => (
  <>
    <VStack spacing={10}>
      <Heading variant="alt" size="lg">Create your account</Heading>
      <CreateAccountForm defaultEmail={defaultEmail} />
    </VStack>
    <Box mt={'20px'}>
      <Text variant={"secondary"} size={"sm"} textAlign={"center"}>
        Already have an account? <Link href={"/login"}><a>Login</a></Link>
      </Text>
    </Box>
  </>
);

Register.getLayout = getRegisterLayout;
Register.allowedRoles = [RoleLevels.OPEN];

export default Register;
